import React from 'react';
import ResourceLinks from 'gatsby-theme-carbon/src/components/LeftNav/ResourceLinks';

const links = [
  {
    title: 'Github',
    href: 'https://github.com/IBM/storage-fusion',
  },
  {
    title: 'Fusion HCI docs',
    href: 'https://www.ibm.com/docs/en/sfhs/2.7.x',
  },
  {
    title: 'Fusion software docs',
    href: 'https://www.ibm.com/docs/en/storage-fusion-software/2.7.x',
  },
];

// shouldOpenNewTabs: true if outbound links should open in a new tab
const CustomResources = () => <ResourceLinks shouldOpenNewTabs links={links} />;

export default CustomResources;
